module.exports = __webpack_public_path__ + "img/ocoInfoSell.682e7930.svg";